import _ from 'underscore';

import Choices from 'choices.js/public/assets/scripts/choices.min.js';
import 'choices.js/public/assets/styles/choices.min.css';

import Beacon from './beacon.js';

var menuTemplate = require("../../../../templates/beacon.handlebars");

const BEACON = "beacon";


export default class BeaconMenu {

	constructor(api, siteData) {
    	this.name = 'BeaconMenu';
        this.api = api;
        this.siteData = siteData;
        this.selectedFeature;
        this.selectedBeacon;
        this.menu;
        this.editMode = false;
        this.editNode;
  	}

  	toString() {
        return this.name;
    }


    initMenu(){
        $("#beacon-body").append(menuTemplate);

        var _this = this;

        this.uuidDD = new Choices('#uuid-dropdown', {
              choices : this.siteData.uuids,
              itemSelectText: 'Click to select'
        });
        
        
        $( "#remove-beacon" ).bind( "click", function(event) {
            event.preventDefault();
            _this.removeBeacon();
        });


        $( "#edit-beacon" ).bind( "click", function(event) {
            event.preventDefault();
            _this.editMode = true;
            _this.editBeacon();
        });

        
        $( "#beacon-cancel" ).bind( "click", function(event) {
            event.preventDefault();
            _this.cancelAddBeacon();
        });

        $( "#beacon-save" ).bind( "click", function(event) {
            event.preventDefault();
            _this.saveBeacon();
        });

        $("#selected-beacon").hide(); // Hide the selected beacon section -- need conditon check here 
    }


    onEditNode(){
        $("#beacon-cancel").show(); // Show cancel option on form
        $("#selected-beacon").show(); // Show point selected
        $("#selected-beacon-name").text(this.selectedBeacon.name);
        $("#beaconManuallySection").hide();

        // populate form data 
        $("#InputBeaconName").val(this.selectedBeacon.name);
        $("#InputBeaconMajor").val(this.selectedBeacon.major);
        $("#InputBeaconMinor").val(this.selectedBeacon.minor);
        this.uuidDD.setChoiceByValue(this.selectedBeacon.uuid);
        $( "#edit-beacon" ).show();

        var props = {
            name : this.selectedBeacon.name,
            major : this.selectedBeacon.major,
            minor : this.selectedBeacon.minor,
            uuid : this.selectedBeacon.uuid
        };
        
        this.editNode =  new Beacon(props);

        
    }

    async saveBeacon(){
        var props = {
            name : $("#InputBeaconName").val(),
            major : $("#InputBeaconMajor").val(),
            minor : $("#InputBeaconMinor").val(),
            uuid : this.uuidDD.getValue().value
        };
        
        let beacon =  new Beacon(props);
        var errors = beacon.validate();


        this.checkValidation(errors);
        
        if(!errors){

            if(!beacon.validateUUID()){
                $( ".validation.beacon-uuid" ).html("<p>UUID invalid<p>" );
                $( '.validation.beacon-uuid' ).parent().addClass('validation-beco');
                return;
            }

            if(this.editMode && beacon.editIsEqual(this.editNode)){
            }else if(this.editMode && beacon.isEqual(this.editNode)){
                this.menu.removeBeacon(this.editNode);
                if(this.menu.isBeaconExist(beacon)){
                    this.menu.addBeacon(this.selectedBeacon);
                    $( ".validation.beacon-name" ).html("<p>Beacon Configuration already exist in this floor<p>" );
                    $( '.validation.beacon-name' ).parent().addClass('validation-beco');
                    return;
                }

            }else if(this.menu.isBeaconExist(beacon)){
                $( ".validation.beacon-name" ).html("<p>Beacon Configuration already exist in this floor<p>" );
                $( '.validation.beacon-name' ).parent().addClass('validation-beco');
                return;
            }else if(this.editMode){
                this.menu.removeBeacon(this.editNode);
            }

            const data =  await this.api.validateBeacon(this.siteData.site_identifier, this.siteData.org_identifier, this.siteData.floor_identifier, props);
            if(data){
                this.selectedBeacon = beacon;
                $("#selected-beacon").show(); // Show beacon selected
                $("#beaconManuallySection").slideToggle(500); // Hide beacon add form
                $("#selected-beacon-name").text(this.selectedBeacon.name);
                $( "#edit-beacon" ).show();
                this.menu.addBeacon(this.selectedBeacon);
            } else {
                $( ".validation.beacon-name" ).html("<p>beacon name already exist in the server<p>" );
                $( '.validation.beacon-name' ).parent().addClass('validation-beco');
            }
            

        } 
        
    }

    checkValidation(errors){
        if(errors && errors['name']){
            $( ".validation.beacon-name" ).html("<p>"+errors['name'].toString()+"<p>" );
            $( '.validation.beacon-name' ).parent().addClass('validation-beco');
        }else {
            $( ".validation.beacon-name p" ).remove();
            $( '.validation.beacon-name' ).parent().removeClass('validation-beco');
        }
        if(errors && errors['major']){
            $( ".validation.beacon-major" ).html("<p>"+errors['major'].toString()+"<p>");
            $( '.validation.beacon-major' ).parent().addClass('validation-beco');
        }else {
            $( ".validation.beacon-major p" ).remove();
            $( '.validation.beacon-major' ).parent().removeClass('validation-beco');
        }

        if(errors && errors['minor']){
            $( ".validation.beacon-minor" ).html("<p>"+errors['minor'].toString()+"<p>");
            $( '.validation.beacon-minor' ).parent().addClass('validation-beco');
        }else {
            $( ".validation.beacon-minor p" ).remove();
            $( '.validation.beacon-minor' ).parent().removeClass('validation-beco');
        }

        if(errors && errors['uuid']){
            $( ".validation.beacon-uuid" ).html("<p>"+errors['uuid'].toString()+"<p>");
            $( '.validation.beacon-uuid' ).parent().addClass('validation-beco');
        }else {
            $( ".validation.beacon-uuid p" ).remove();
            $( '.validation.beacon-uuid' ).parent().removeClass('validation-beco');
        }
    }


    cancelAddBeacon(){
        $("#beaconManuallySection").slideToggle(500);
        $("#selected-beacon").show();
    }

    
    getMenu() {
        return this;
    }

    open(feature, menu){
        this.initMenu();
        this.selectedFeature = feature;
        this.menu = menu;
        if(feature.getProperties() && feature.getProperties().beacon){
            this.selectedBeacon = this.getOrCreateBeacon(feature.getProperties().beacon);
            this.onEditNode();
        }
        this.editMode = false;
    }

    save(){
        let props = {};
        if(this.selectedFeature) props['beacon'] = this.selectedBeacon;
        this.selectedFeature.setProperties(props);

        this.selectedFeature = null;
        this.selectedBeacon = null;
        this.beaconCache = {};
        $("#beacon-side-menu").remove();
    }    

    removeBeacon(){
        if(this.selectedBeacon){
            this.menu.removeBeacon(this.selectedBeacon);
            this.selectedBeacon = null;

            $("#beacon-cancel").hide();
            $("#beaconManuallySection").show();
            $("#selected-beacon-name").text(""); // Reset the beacon name
            $("#selected-beacon").hide(); // Hide beacon selected

        }
    }

    editBeacon(){
        if(this.selectedBeacon){
            $("#selected-beacon").hide(); // Hide beacon selected
            $("#beaconManuallySection").slideToggle(500);
            $("#selected-beacon-name").text(this.selectedBeacon.name);
            $("#InputBeaconName").val(this.selectedBeacon.name); 

            var props = {
                name : this.selectedBeacon.name,
                major : this.selectedBeacon.major,
                minor : this.selectedBeacon.minor,
                uuid : this.selectedBeacon.uuid
            };
            
            this.editNode =  new Beacon(props);

        }
    }
    

    static get getBeaconVariable() {
        return BEACON;
    }

    getOrCreateBeacon(params){
        var props = {
            major : params.major,
            minor : params.minor,
            uuid : params.uuid,
            name : params.name
        };
        let beacon =  new Beacon(props);

        return beacon;
    }


    


}